import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CadastrarEditalComponent } from './cadastrar-edital.component';
import { FiltroDinamicoModule }  from 'unb-questionario-componente';
import { CadastrarEditalRoutingModule } from './cadastrar-edital.routes';

@NgModule({
  imports: [
    CommonModule, FiltroDinamicoModule, CadastrarEditalRoutingModule
  ],
  declarations: [CadastrarEditalComponent]
})
export class CadastrarEditalModule { }
